import { useReportBuilderStore } from '../../stores/reportBuilderStore';
import { Plus, Trash } from '@phosphor-icons/react';
import type { FilterOperator } from '../../types/reportBuilder';
import { OPERATOR_LABELS, HAVING_OPERATORS } from '../../types/reportBuilder';

export default function HavingFilterBuilder() {
  const { selectedMeasures, havingFilters, addHavingFilter, removeHavingFilter, updateHavingFilter } = useReportBuilderStore();

  if (selectedMeasures.length === 0) return null;

  const handleAdd = () => {
    const first = selectedMeasures[0];
    if (!first) return;
    addHavingFilter({ measure_alias: first.alias, operator: 'gt', value: '' });
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">Having Filters</span>
        <button onClick={handleAdd} className="flex items-center gap-1 rounded px-2 py-1 text-xs text-blue-600 hover:bg-blue-50">
          <Plus className="h-3 w-3" /> Add Having
        </button>
      </div>
      <p className="text-xs text-gray-400">Filter on aggregate values (e.g. "count &gt; 10").</p>

      {havingFilters.map((hf) => (
        <div key={hf.id} className="space-y-1 rounded border border-gray-200 bg-gray-50 p-2">
          <div className="flex items-center gap-1">
            <select
              value={hf.measure_alias}
              onChange={(e) => updateHavingFilter(hf.id, { measure_alias: e.target.value })}
              className="flex-1 rounded border border-gray-300 px-2 py-1 text-xs focus:border-blue-500 focus:outline-none"
            >
              {selectedMeasures.map(m => (
                <option key={m.alias} value={m.alias}>{m.alias} ({m.aggregation})</option>
              ))}
            </select>
            <select
              value={hf.operator}
              onChange={(e) => {
                const op = e.target.value as FilterOperator;
                updateHavingFilter(hf.id, { operator: op, value: op === 'between' ? ['', ''] : '' });
              }}
              className="rounded border border-gray-300 px-2 py-1 text-xs focus:border-blue-500 focus:outline-none"
            >
              {HAVING_OPERATORS.map(op => (
                <option key={op} value={op}>{OPERATOR_LABELS[op] || op}</option>
              ))}
            </select>
            <button onClick={() => removeHavingFilter(hf.id)} className="rounded p-1 text-gray-400 hover:bg-red-50 hover:text-red-500">
              <Trash className="h-3.5 w-3.5" />
            </button>
          </div>
          {hf.operator === 'between' ? (
            <div className="flex gap-1">
              <input type="number" value={String((Array.isArray(hf.value) ? hf.value[0] : '') ?? '')}
                onChange={(e) => { const arr = Array.isArray(hf.value) ? hf.value : ['', '']; updateHavingFilter(hf.id, { value: [e.target.value ? Number(e.target.value) : '', arr[1] ?? ''] }); }}
                className="w-full rounded border border-gray-300 px-2 py-1 text-xs focus:border-blue-500 focus:outline-none" placeholder="From" />
              <input type="number" value={String((Array.isArray(hf.value) ? hf.value[1] : '') ?? '')}
                onChange={(e) => { const arr = Array.isArray(hf.value) ? hf.value : ['', '']; updateHavingFilter(hf.id, { value: [arr[0] ?? '', e.target.value ? Number(e.target.value) : ''] }); }}
                className="w-full rounded border border-gray-300 px-2 py-1 text-xs focus:border-blue-500 focus:outline-none" placeholder="To" />
            </div>
          ) : (
            <input type="number" value={String(hf.value ?? '')}
              onChange={(e) => updateHavingFilter(hf.id, { value: e.target.value ? Number(e.target.value) : '' })}
              className="w-full rounded border border-gray-300 px-2 py-1 text-xs focus:border-blue-500 focus:outline-none" placeholder="Value" />
          )}
        </div>
      ))}
      {havingFilters.length === 0 && <p className="text-xs text-gray-400 italic">No having filters applied</p>}
    </div>
  );
}
